<section id="montreal-hoteis" class="section">
  <div class="container is-fullhd">

<!--    <div class="area-step-category" [class]="page === 'home' ? 'area-step-category home' : 'area-step-category hotel'">-->
<!--      <div class="step-one">-->
<!--        <h3 class="subtitle">O que você deseja?</h3>-->
<!--        <div class="item-check icon-praia cursor-pointer"><a routerLink="/busca-hoteis"-->
<!--            [queryParams]="{ tipoComodidade:23 }"><i class="fas fa-sun"></i><span>Praia</span></a></div>-->
<!--        <div class="item-check icon-luxo cursor-pointer"><a routerLink="/busca-hoteis"-->
<!--            [queryParams]="{ tipoApartamento:[3,14] }"><i class="fas fa-gem"></i><span>Luxo</span></a></div>-->
<!--        <div class="item-check icon-relaxar cursor-pointer"><a routerLink="/busca-hoteis"-->
<!--            [queryParams]="{ tipoComodidade:24 }"><i class="fas fa-spa"></i><span>Relaxar</span></a></div>-->
<!--        <div class="item-check icon-natureza cursor-pointer"><a routerLink="/busca-hoteis"-->
<!--            [queryParams]="{ tipoComodidade:19 }"><i class="fas fa-mountain"></i><span>Natureza</span></a></div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="columns" [class]="page === 'home' ? 'columns columns-home': 'columns columns-hotel'">
      <div class="column is-12">
        <h1>Hotéis</h1>
<!--        <p>-->
<!--          Os melhores e mais incríveis hotéis no Brasil e no exterior. Conte com aconchegantes-->
<!--          <br>-->
<!--          pousadas, hotéis maravilhosos e até aquele resort all inclusive à beira mar. Hospede-se-->
<!--          <br>-->
<!--          com a gente nos mais variados destinos!-->
<!--        </p>-->
        <p>
          Hotéis, pousadas, resorts, hotéis fazenda… Não importa o tipo de acomodação, as
          <br>
          melhores opções estão aqui aguardando por você.
        </p>
        <a class="link-all" routerLink="/busca-hoteis" style="padding-left: 0.5%">
          <span>Todos os hotéis</span>
          <i class="fa fa-chevron-right"></i>
        </a>

      </div>
    </div>

    <div id="destaques">
      <div class="columns" *ngIf="destaqueList && destaqueList.length > 0">
        <div class="column is-9">
          <h4 class="title">Destaques</h4>
        </div>
      </div>

      <div class="columns" *ngIf="destaqueList && destaqueList.length > 0">
        <div class="column" *ngFor="let hotel of destaqueList.slice(0,2)">
          <div class="item-hotel medium-hotel" [style.backgroundImage]="'url('+ hotel.fotos[0] +')'" [attr.aria-label]="hotel.alt">
            <div class="overlay-img"></div>
            <a (click)="navegarParaDetalheHotel(hotel)">
              <div class="description-hotel">
                <h3>{{hotel.nome}}</h3>
                <p>{{hotel.cidade}},{{hotel.uf}}</p>
                <p>{{hotelDescricao(hotel.descricao)}}</p>
              </div>
            </a>
          </div>
        </div>

      </div>
    </div>


    <div id="premium">
      <div class="columns" *ngIf="premiumList && premiumList.length > 0">
        <div class="column">
          <h4 class="title">Premium</h4>
        </div>
      </div>

      <div class="columns" *ngIf="premiumList && premiumList.length > 0">
        <div class="column" *ngFor="let hotel of premiumList.slice(0,3)">
          <div class="item-hotel small-hotel">
            <div class="bg-hotel" [style.backgroundImage]="'url('+ hotel.fotos[0] +')'" [attr.aria-label]="hotel.alt"></div>
            <div class="overlay-img"></div>
            <a (click)="navegarParaDetalheHotel(hotel)">
              <div class="description-hotel">
                <h3 class="h3-title">{{hotel.nome}}</h3>
                <p>{{hotel.cidade}}, {{hotel.uf}}</p>
              </div>
              <div class="footer-hotel">
                <div class="columns">
                  <div class="column">
                    <small>{{hotelDescricao(hotel.descricao)}}</small>
                  </div>
                </div>
                <div class="columns column-price">
                  <div class="column is-5">
                    <p class="preco-diaria" *ngIf="hotel.valorDiariaHotel"><strong>Diária<br>R$
                      <del>{{hotel.valorDiariaHotel ? hotel.valorDiariaHotel : 0}}*</del></strong></p>
                  </div>
                  <div class="column has-text-right area-btn-diarias" *ngIf="page === 'home'">
                    <button href="#" class="btn btn-common">Saiba Mais</button>
                  </div>
                  <div class="column has-text-right area-btn-diarias area-responsive" *ngIf="page === 'hoteis'">
                    <button href="#" class="btn btn-common">Saiba Mais</button>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>


    <div id="novos">
      <div class="columns" *ngIf="novoList && novoList.length > 0">
        <div class="column">
          <h4 class="title">Novos</h4>
        </div>
      </div>

      <div class="columns" *ngIf="novoList && novoList.length > 0">
        <div class="column" *ngFor="let hotel of novoList.slice(0,3)">
          <div class="item-hotel small-hotel" *ngIf="hotel">
            <div class="bg-hotel" [style.backgroundImage]="'url('+ hotel.fotos[0] +')'" [attr.aria-label]="hotel.alt"></div>
            <div class="overlay-img"></div>
            <a (click)="navegarParaDetalheHotel(hotel)">
              <div class="description-hotel">
                <h3 class="h3-title">{{hotel.nome}}</h3>
                <p>{{hotel.cidade}}, {{hotel.uf}}</p>
              </div>
              <div class="footer-hotel">
                <div class="columns">
                  <div class="column">
                    <small>{{hotelDescricao(hotel.descricao)}}...</small>
                  </div>
                </div>
                <div class="columns column-price">
                  <div class="column is-5">
                    <p class="preco-diaria" *ngIf="hotel.valorDiariaHotel"><strong>Diária<br>R$
                      <del>{{hotel.valorDiariaHotel ? hotel.valorDiariaHotel : 0}}*</del></strong></p>
                  </div>
                  <div class="column has-text-right area-btn-diarias" *ngIf="page === 'home'">
                    <button href="#" class="btn btn-common">Saiba Mais</button>
                  </div>
                  <div class="column has-text-right area-btn-diarias area-responsive" *ngIf="page === 'hoteis'">
                    <button href="#" class="btn btn-common">Saiba Mais</button>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

      </div>
    </div>

    <div class="columns">
      <div class="column text-center">
        <a class="link-all link-bold" routerLink="/busca-hoteis"><span>Todos os hotéis</span></a>
      </div>
    </div>
  </div>
</section>
